
import { Component, Vue } from "vue-property-decorator";
import Swal from "sweetalert2";
import { AxiosResponse } from 'axios';
import AfiliadoService from '@/services/AfiliadoService';
import ServiceResponse from '@/services/response-models/ServiceResponse';
import CambioClave from '../models/CambioClave';
import User from '@/models/User';
import { Getter } from 'vuex-class';
import IframeCommunicatorService, { InterPagesMessages, MessageTypes } from "@/services/IframeCommunicatorService";
import VeeValidateForm from '@/vee-validate/types/VeeValidateForm';

@Component
export default class CambioContrasena extends Vue {
    public afiliadoService: AfiliadoService = new AfiliadoService();
    public cambioClave: CambioClave = new CambioClave();
    public confirmacionNuevaContrasena: string = null;
    @Getter('user') usuario: User;
    public loading: boolean = false;
    public iframeService = new IframeCommunicatorService();

    public mounted(): void {
        if (this.$route.query.blockNavigation) {
            this.iframeService
                .postMessageToParent(new InterPagesMessages(MessageTypes.BlockUserLinks, ""));
        }
        if (this.usuario) {
            this.cambioClave.codUsuario = this.usuario.cedula;
        }
    }
    public cancelar() {
        if (this.$route.query.blockNavigation) {
            this.$store.dispatch("logOut");
            this.iframeService
                    .postMessageToParent(new InterPagesMessages(MessageTypes.LogOut, ""));
            return;
        }
        this.iframeService.postMessageToParent(
                                            new InterPagesMessages(
                                            MessageTypes.Redirect,
                                            "/default.aspx"
                                            )
                                        );

    }

    public checkForValidPassword(): boolean{
        if (this.cambioClave.claveActual !== null && this.cambioClave.claveActual !== undefined) {
            return this.cambioClave.claveActual === '' || this.cambioClave.claveActual.length < 10;
        }
        return false;
    }

    public changePassword(): void {
        var self = this;
        this.formIsValid().then((isValid: boolean) => {
            if (isValid) {
                self.loading = true;
                // console.log("Loading set to: "+ this.loading);
                this.afiliadoService.cambiarClave(this.cambioClave)
                    .then((response: AxiosResponse<ServiceResponse>) => {
                        if (response.data.respCode === 200) {
                            Swal.fire({
                                text: 'Clave cambiada',
                                icon: 'success',
                                showConfirmButton: false,
                                timer: 3000,
                                onClose: () => {
                                    // this.$router.push('/');
                                    this.iframeService.postMessageToParent(
                                                  new InterPagesMessages(
                                                    MessageTypes.Redirect,
                                                    "/default.aspx"
                                                  )
                                                );
                                    //window.history.back();
                                }
                            });
                        } else if (response.data.respCode === 1001) {
                            Swal.fire({
                                text: 'La clave anterior es incorrecta',
                                icon: 'warning'
                            });
                        } else {
                            Swal.fire({
                                text: 'No se pudo cambiar tu clave, inténtalo de nuevo',
                                icon: 'error'
                            });
                        }
                    });
            }
        })
        .finally(() => {
            self.loading = false;
        });
    }

    public async formIsValid() {
        let isValid: boolean = false;
        if (!(this.$refs.currentPasswordForm as any)) {
            return isValid;
        }
        isValid = await (this.$refs.currentPasswordForm as VeeValidateForm).validate();
        const lessThan10Chars = !this.cambioClave.claveActual || this.cambioClave.claveActual.length < 10;
        const passwordsMatch = this.cambioClave.claveActual === this.confirmacionNuevaContrasena;
        return isValid && !lessThan10Chars && passwordsMatch;
    }
}
